import React, {Component} from "react";

class WinnerImage extends Component{
    render() {
        const {linkImage} = this.props;
        return (
            <>
                <div className="boxImage txt-center">
                    <img src={linkImage} alt=""/>
                </div>
            </>
        );
    }
}
export default WinnerImage;